interface SellerCompletionMessageProps {
  isRegistering?: boolean;
  isSuccess?: boolean;
  className?: string;
}

export function SellerCompletionMessage({ 
  isRegistering = false, 
  isSuccess = false,
  className = '' 
}: SellerCompletionMessageProps) {
  
  if (isRegistering) {
    return (
      <div className={`text-center ${className}`}>
        <div className="w-20 h-20 mx-auto mb-8 bg-blue-100 rounded-full flex items-center justify-center">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
        <h1 className="text-[32px] font-bold text-[#222222] mb-6">회원가입 처리 중...</h1>
        <p className="text-[18px] text-gray-600 mb-8">
          입력하신 정보를 처리하고 있습니다.<br />
          잠시만 기다려주세요.
        </p>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className={`text-center ${className}`}>
        <div className="w-20 h-20 mx-auto mb-8 bg-green-100 rounded-full flex items-center justify-center">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-[32px] font-bold text-[#222222] mb-6">회원가입 완료!</h1>
        <p className="text-[18px] text-gray-600 mb-8">
          판매자 회원가입이 성공적으로 완료되었습니다.<br />
          에코딜과 함께 지속가능한 미래를 만들어가요! 🌱
        </p>
        
        <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8">
          <h3 className="text-[18px] font-semibold text-green-700 mb-3">
            🎉 환영합니다!
          </h3>
          <p className="text-[16px] text-green-600">
            이제 음식물 쓰레기를 줄이고 추가 수익을 창출할 수 있습니다.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`text-center ${className}`}>
      <div className="w-20 h-20 mx-auto mb-8 bg-red-100 rounded-full flex items-center justify-center">
        <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <h1 className="text-[32px] font-bold text-[#222222] mb-6">처리 중 오류 발생</h1>
      <p className="text-[18px] text-gray-600 mb-8">
        회원가입 처리 중 문제가 발생했습니다.<br />
        다시 시도하거나 고객센터에 문의해주세요.
      </p>
    </div>
  );
}